import Resource from './resource'

export default Resource